import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';
import { isLayoutViewActive } from './layoutModeSelectors';

export const isThereAnUndoableAction = createSelector(
  isLayoutViewActive,
  (state: RootState) => state.layout.undoRedoChain,
  (state: RootState) => state.editor.undoRedoChains,
  getActiveComponentDesign,
  (layoutViewIsActive, layoutUndoRedoChain, componentDesignUndoRedoChains, activeComponentDesign) =>
    layoutViewIsActive
      ? !!layoutUndoRedoChain.undo
      : !!(activeComponentDesign && componentDesignUndoRedoChains[activeComponentDesign.guid]?.undo),
);

export const isThereARedoableAction = createSelector(
  isLayoutViewActive,
  (state: RootState) => state.layout.undoRedoChain,
  (state: RootState) => state.editor.undoRedoChains,
  getActiveComponentDesign,
  (layoutViewIsActive, layoutUndoRedoChain, componentDesignUndoRedoChains, activeComponentDesign) =>
    layoutViewIsActive
      ? !!layoutUndoRedoChain.redo
      : !!(activeComponentDesign && componentDesignUndoRedoChains[activeComponentDesign.guid]?.redo),
);
